
import { defineComponent } from "vue";

import ContainerCatalogue from "@/components/catalogues/ContainerCatalogue/ContainerCatalogue.vue";

export default defineComponent({
  components: { ContainerCatalogue },
  props: {},
  methods: {},
  data() {
    return {};
  },
});
